import { computed } from 'vue'
import { Products } from '@one/types'

export default function useUtils(vm) {
  const priceTypeLabel = computed(() => vm.$store.getters['layout/isGrossSelected'] ? vm.$t('price.gross') : vm.$t('price.net'))

  const isTileCalculator = (product: Products.Product | null) => {
    return product?.labels.includes('tile_calculator')
  }

  return { priceTypeLabel, isTileCalculator }
}
